import { useTranslation } from 'react-i18next';
import CategoryDropdown from './CategoryDropdown';

export default function HeroSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background-50">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20geometric%20abstract%20composition%20with%20flowing%20organic%20waves%20and%20gentle%20curves%2C%20serene%20mint%20green%20and%20warm%20peach%20cream%20tones%20blending%20harmoniously%2C%20minimal%20artist%20gallery%20wall%20texture%20with%20subtle%20grain%2C%20airy%20light%20atmosphere%2C%20contemporary%20clean%20aesthetic%2C%20peaceful%20calming%20mood%2C%20no%20harsh%20edges&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50" />
      </div>

      {/* Hero product cards - decorative */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 z-10 hidden lg:flex items-end justify-center gap-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20streetwear%20sneakers%20displayed%20on%20clean%20minimal%20white%20pedestal%2C%20editorial%20product%20photography%2C%20soft%20natural%20diffused%20window%20light%20from%20left%20side%2C%20warm%20beige%20environment%2C%20modern%20urban%20fashion%20aesthetic%2C%20elegant%20product%20composition%2C%20subtle%20reflection%20on%20surface%2C%20professional%20high%20quality%20detailed%20footwear%20shot&width=400&height=560&seq=hero-card-v2-left&orientation=portrait"
          alt=""
          className="w-52 h-72 object-cover rounded-2xl transform -rotate-3 translate-y-4"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20oversized%20hoodie%20elegantly%20draped%20on%20invisible%20mannequin%20form%2C%20luxury%20editorial%20fashion%20photography%2C%20soft%20golden%20hour%20natural%20light%2C%20warm%20peachy%20cream%20backdrop%2C%20modern%20streetwear%20aesthetic%2C%20clean%20sophisticated%20composition%2C%20high%20quality%20fabric%20texture%20visible%2C%20minimal%20styling&width=400&height=560&seq=hero-card-v2-center&orientation=portrait"
          alt=""
          className="w-56 h-80 object-cover rounded-2xl transform translate-y-0 z-20"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Designer%20graphic%20print%20t-shirt%20neatly%20arranged%20on%20pristine%20white%20surface%2C%20high%20fashion%20editorial%20product%20photography%2C%20soft%20natural%20daylight%20from%20overhead%2C%20warm%20vanilla%20cream%20environment%2C%20contemporary%20boutique%20aesthetic%2C%20elegant%20minimal%20presentation%2C%20sharp%20detail%20on%20print%20design%2C%20sophisticated&width=400&height=560&seq=hero-card-v2-right&orientation=portrait"
          alt=""
          className="w-52 h-72 object-cover rounded-2xl transform rotate-3 translate-y-4"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 w-full flex flex-col items-center px-4 md:px-6 pt-32 pb-72 lg:pb-96">
        {/* Titles */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-foreground-950 leading-tight">
            {t('hero.title1')}
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-800 mt-2">
            {t('hero.title2')}
          </p>
          <p className="text-xl md:text-2xl font-heading text-foreground-600 mt-3">
            {t('hero.title3')}
          </p>
          <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-xl mx-auto leading-relaxed">
            {t('hero.subtitle')}
          </p>
        </div>

        {/* Category Dropdown */}
        <div className="w-full max-w-md mb-6">
          <CategoryDropdown />
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta1')}
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center" />
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta2')}
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}